import { actionTypes } from "./actions";

const initialState = {
  connectionState: "NOT_CONNECTED",
  content: null,
  isLibraryLoaded: false,
  isMediaLoaded: false
};

const chromecast = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.CONNECTION_STATE_CHANGED:
      return { ...state, connectionState: payload };
    case actionTypes.CONTENT_CHANGED:
      return { ...state, content: payload, isMediaLoaded: false };
    case actionTypes.CONTENT_LOADED:
      return { ...state, isMediaLoaded: true };
    case actionTypes.LIBRARY_LOADED:
      return { ...state, isLibraryLoaded: true };
    case actionTypes.RECEIVER_CONTENT_CHANGED:
      // Already loading the new asset so no need to reset the content
      if (!state.isMediaLoaded && !payload) return state;

      return { ...state, content: payload, isMediaLoaded: !!payload };
    default:
      return state;
  }
};

export default chromecast;
